import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { DialogService } from "ng2-bootstrap-modal";
import { ConfirmComponent } from "../../../shared/confirm/confirm.component";
import { Router, ActivatedRoute } from '@angular/router';


import * as _ from 'underscore';

// Service
import { MovecustomerstructureService } from '../../service/movecustomerstructure/movecustomerstructure.service';

@Component({
	selector: 'app-movecustomerstructure',
	templateUrl: './movecustomerstructure.component.html',
	providers: [
		MovecustomerstructureService,
		HttpModule
	]
})
export class MovecustomerstructureComponent implements OnInit {

	private token;
	public accountClients: any[];
	public selectedClients = new Set();
	public ctcs: any[] = [];
	public representantes: any[] = [];
	public selectedCTC: string = '';
	public selectedRepres: string = '';
	public resultCount: number = 0;
	public repSearch: string = '';
	public orderby: string = "Nome";
	public sort: string = "asc";
	public permissoes: any[] = [];
	public CodigoPrincipal;
	public accountClientID: string = "";
	// public hasLC: boolean;
	// public page;
	// public proposals: any[] = [];
	// public number: number = 0;
	// public ctcValue: string = "";
	currentPage: number = 0;
	accountClient: FormGroup;
	routSubscription: any;

	constructor(fb: FormBuilder, private MovecustomerstructureService: MovecustomerstructureService, private flashMessagesService: FlashMessagesService, private dialogService: DialogService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
		this.accountClient = fb.group({
			'CodigoPrincipal': '',
			'Nome': '',
			'Documento': '',
			'Apelido': '',
			'Representante': '',
			'CTC': '',
			'GC': '',
			'DC': '',
			'Lista': []
		});
	}

	ngOnInit() {

		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];

		this.routSubscription = this.route.params.subscribe(params => {
			if (params['CodigoPrincipal']) {
				this.accountClient.value.CodigoPrincipal = params['CodigoPrincipal'];
				this.CodigoPrincipal = params['CodigoPrincipal'];
				this.searchAccountClient(this.accountClient.value, 0, true);
			}
			this.accountClientID = params['ContaClienteID'];
		});
		this.getCTC();
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc";
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchAccountClient(this.accountClient.value, this.currentPage, false);
	}

	searchAccountClient(value: any, page, isSearch) {
		this.selectedClients.clear();
		if (isSearch) {
			this.orderby = "Nome";
			this.sort = "asc";
			this.currentPage = 0;
		}
		this.MovecustomerstructureService.getAccountClient(
			this.token,
			value.CodigoPrincipal,
			value.Nome,
			value.Documento,
			value.Apelido,
			value.Representante,
			value.CTC,
			value.GC,
			value.DC,
			this.orderby,
			this.sort,
			page)
		.subscribe(result => {
				if (result.Success) {
					this.accountClients = result.Result;
					this.resultCount = result.Count;
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
		}, error => {
				console.log(error);

		})
	}

	searchCTC() {
		this.MovecustomerstructureService.searchRepresentante(this.token,this.repSearch).subscribe(result => {
			if (result.Success) {
				this.representantes = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	getCTC() {
		this.MovecustomerstructureService.getCTC(this.token).subscribe(result => {
			if (result.Success) {
				this.ctcs = result.Result.sort((c1,c2) => {
					if (c1.Nome > c2.Nome) return 1;
					if (c2.Nome > c1.Nome) return -1;
					return 0;
				});
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		});
	}

	setCTC(value) {
		this.selectedCTC = value;
	}

	setRepres(value) {
		this.selectedRepres = value;
	}

	//insert a new commercial structure on client's account or active an existing one
	addCTC() {

		var comlStructure = {
			CodigoSap:this.selectedCTC,
			Ativo: true,
			ContaClientes: Array.from(this.selectedClients).map(id => ({ "ID" : id }))
		}
		
		this.MovecustomerstructureService.setCustomerStrucuture(this.token, comlStructure).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("O CTC foi adicionado as Contas Cliente selecionadas.", { cssClass: 'alert-success', timeout: 6000 });
				if (this.accountClientID) {
					this.router.navigateByUrl('/conta-cliente/detalhe/' + this.accountClientID);
				} else {
					this.searchAccountClient(this.accountClient.value, this.currentPage, false);
				}
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				this.changeRouteToCockpit();

			}
		}, error => {
			console.log(error);

		});
	}

	//insert a new representative on commercial structure that already exists on client's account
	addRep() {

		var repCommercialStructure = {
			CodigoSap:this.selectedCTC,
			RepresentanteID: this.selectedRepres,
			Ativo: true,
			ContaClientes: Array.from(this.selectedClients).map(id => ({ "ID" : id }))
		}

		this.MovecustomerstructureService.setCustomerRep(this.token, repCommercialStructure).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("O representante foi adicionado as Contas Cliente selecionadas.", { cssClass: 'alert-success', timeout: 6000 });
				if (this.accountClientID) {
					this.router.navigateByUrl('/conta-cliente/detalhe/' + this.accountClientID);
				} else {
					this.searchAccountClient(this.accountClient.value, this.currentPage, false);
				}
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				this.changeRouteToCockpit();
			}
		}, error => {
			console.log(error);
		});
	}

	changeRouteToCockpit(){
		this.router.navigateByUrl('/').then(
			() => {
				this.router.navigateByUrl('/cockpit');
			});
	}

	selectAll() {
		$('.client-list tbody tr td input').prop('checked', $(document).find('#selectAll').is(':checked'))
	}

	selectRow(e,id) {

		if (e == true) {
			this.selectedClients.add(id);
		} else {
			if (this.selectedClients.has(id))
			this.selectedClients.delete(id);
		}

	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchAccountClient(this.accountClient.value, $event, false);
	}

	//remove a client commercial structure 	 
	removeComlStructure(contaClienteId: string, estruturaComercialId: string, representanteId: string) {
		let disposable = this.dialogService.addDialog(ConfirmComponent, {
			title: 'Confirmar Exclusão',
			message: `Confirma a exclusão${!!representanteId ? ' do representante' : ''} da estrutura comercial?`
		},
		{
			backdropColor: 'rgba(0, 0, 0, 0.5)'
		}).subscribe((isConfirmed) => {
			if (isConfirmed) {

				if (!!representanteId)
				{
					this.removeRep(contaClienteId, estruturaComercialId, representanteId)
				}
				else
				{
					this.removeCTC(contaClienteId, estruturaComercialId);
				}
			}
		});
	}

	removeCTC(contaClienteId: string, estruturaComercialId: string) {
				
		var comlStructure = {
			CodigoSap: estruturaComercialId,
			Ativo: false,
			ContaClientes: [{ "ID" : contaClienteId }]
		}

		this.MovecustomerstructureService.setCustomerStrucuture(this.token, comlStructure)
		.subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Estrutura comercial removida com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
				window.location.reload();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				this.changeRouteToCockpit();
			}
		}),
		error => {
			console.log(error);        
		}
	}

	removeRep(contaClienteId: string, estruturaComercialId: string, representanteId: string) {

		var repCommercialStructure = {
			CodigoSap: estruturaComercialId,
			RepresentanteID: representanteId,
			Ativo: false,
			ContaClientes: [{ "ID" : contaClienteId }]
		}

		this.MovecustomerstructureService.setCustomerRep(this.token, repCommercialStructure).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Representante removido da estrutura comercial com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
				window.location.reload();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				this.changeRouteToCockpit();
			}
		}, error => {
			console.log(error);
		});
	}
}


// WEBPACK FOOTER //
// ./src/app/movecustomerstructure/component/movecustomerstructure/movecustomerstructure.component.ts